import React from 'react';
import { object } from 'prop-types';
import { Provider } from 'react-redux';

import {
    Router,
    Switch,
    Route,
    Link,
    StaticRouter,
} from 'react-router-dom';

import routes from '../universal/routes';

const renderRoutes = (routes, extraProps = {}, switchProps = {}) => (routes ? (
    <Switch {...switchProps}>
        { routes.map((route, i) => (
            <Route
                key={i}
                path={route.path}
                exact={route.exact}
                strict={route.strict}
                render={props => (
                    <route.component {...props} {...extraProps} route={route} />
                )}
            />
        )) }
    </Switch>
) : null);


const App = ({ store, history }) => (
    <Provider store={store}>
        <Router history={history}>
            { renderRoutes(routes) }
        </Router>
    </Provider>
);

App.propTypes = {
    store: object.isRequired,
    history: object.isRequired,
};

export default App;
